import axios from "axios";
import { GetAllAdminDTO } from "../../dto";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";

type GetAllAdminProps = {
  page: number;
  pageSize: number;
  email?: string;
  createdOrder?: "ASC" | "DESC" | "";
  updatedOrder?: "ASC" | "DESC" | "";
};

let body: GetAllAdminDTO;

export async function getAllAdminAction(props: GetAllAdminProps) {
  const token = localStorage.getItem("token");

  const params = {
    page: props.page,
    pageSize: props.pageSize,
    email: props.email,
    createdOrder: props.createdOrder !== "" ? props.createdOrder : undefined,
    updatedOrder: props.updatedOrder !== "" ? props.updatedOrder : undefined,
  };

  return await axios
    .get(`${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/admins/get-all`, {
      headers: {
        "Content-Type": "application/json",
        "app-platform": "cms",
        Authorization: `Bearer ${token}`,
      },
      params,
    })
    .then(async (res) => {
      body = plainToClass(GetAllAdminDTO, res.data);
      const errors = await validate(body);

      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
